var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected-company"},[_vm._v(" "+_vm._s(_vm.$t("message.permissions.selectedCompany"))+": "),_c('span',{staticClass:"selected-company-name"},[_vm._v(" "+_vm._s(_vm.company.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }